import StarRoundedIcon from "@mui/icons-material/StarRounded";
import classes from "./quickResultProviderCard.module.scss";

const STAR_SIZE = 16;
const STAR_COUNT = 5;
const FILLED_COLOR = "#f59e0b";
const EMPTY_COLOR = "#e5e7eb";

const QuickResultStarRating = ({ value = 0, max = STAR_COUNT }) => {
  const safeValue = Math.min(max, Math.max(0, Number(value) || 0));

  return (
    <span className={classes.starRating} aria-hidden="true">
      {Array.from({ length: max }, (_, index) => {
        const fill = Math.min(1, Math.max(0, safeValue - index));

        return (
          <span key={index} className={classes.starSlot}>
            <StarRoundedIcon
              className={classes.starIcon}
              sx={{ fontSize: STAR_SIZE, color: EMPTY_COLOR }}
            />
            {fill > 0 ? (
              <span
                className={classes.starFillClip}
                style={{ width: `${fill * 100}%` }}
              >
                <StarRoundedIcon
                  className={classes.starIcon}
                  sx={{ fontSize: STAR_SIZE, color: FILLED_COLOR }}
                />
              </span>
            ) : null}
          </span>
        );
      })}
    </span>
  );
};

export default QuickResultStarRating;
